import { Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from "./AddRoutesJson";
import LayoutWrapper from "./LayoutWrappers";
import PrivateRoutesAuth from "./PrivateRoutesAuth";
import { useCookies } from "react-cookie";

const RouterMain = () => {
  const cookies = localStorage;
  const renderRoute: any = () => {
    return PRIVATE_ROUTES.filter((route) =>
      route.accessTo.includes(
        cookies?.user ? JSON.parse(atob(cookies?.user))?.User_type : ""
      )
    ).map((route, index) => (
      <Route
        key={"_key_Id_Pro" + index + route.path}
        path={route.path}
        element={
          <LayoutWrapper layoutIdentifier={route.layoutType}>
            <Suspense fallback={route.loadingFallback}>
              {route.component}
            </Suspense>
          </LayoutWrapper>
        }
      />
    ));
  };

  return (
    <>
      <BrowserRouter>
        <Routes>
          {cookies?.user && cookies?.accessToken ? (
            <>
              {/* <Route
                path="*"
                element={
                  <Navigate
                    replace
                    to={
                      JSON.parse(atob(cookies.user))?.User_type == "Admin"
                        ? "/dashboard"
                        : "/chat"
                    }
                  />
                }
              /> */}
              <Route
                path="*"
                element={<Navigate replace to={"/dashboard"} />}
              />
              <Route element={<PrivateRoutesAuth />}>{renderRoute()}</Route>
            </>
          ) : (
            <>
              {PUBLIC_ROUTES.map((route, index) => (
                <Route
                  key={"_key_Id_" + index + route.path}
                  path={route.path}
                  element={
                    <LayoutWrapper layoutIdentifier={route.layoutType}>
                      <Suspense fallback={route.loadingFallback}>
                        {route.component}
                      </Suspense>
                    </LayoutWrapper>
                  }
                />
              ))}
            </>
          )}
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default RouterMain;
